<!--  -->
<template>
  <footer class="footer">
    <div class="top">
      <div class="content">
        <div class="title">{{ $t("message.bottom.companyName") }}</div>
        <div class="info email_info">
          <span>{{ $t("message.bottom.emailLabel") }}</span>
          <img class="email_img" src="@/assets/email.png" alt="" />
        </div>
        <div class="info">{{ $t("message.bottom.address") }}</div>
        <div class="info">{{ $t("message.bottom.office") }}</div>
      </div>
    </div>
    <div class="bottom">
      <div class="info">
        ©2022 {{ $t("message.bottom.companyName") }}
        {{ $t("message.bottom.copyText") }}
      </div>
      <div class="info links">
        <a href="#">{{ $t("message.bottom.privacy") }}</a>
        <span class="sep">|</span>
        <a href="#">{{ $t("message.bottom.privacyPolicy") }}</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>
<style lang='scss' scoped>
.footer {
  width: 100%;
  text-align: center;
  background-color: $footer-bg;
  color: #666;

  .top {
    padding: 24px 16px 18px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);

    .content {
      font-size: 13px;
      line-height: 1.6;

      .title {
        font-size: 16px;
        font-weight: 600;
        color: $text-dark;
        margin-bottom: 8px;
      }

      div {
        margin-bottom: 2px;
      }

      .email_info {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 2px;
        flex-wrap: wrap;
      }

      .email_img {
        width: auto;
        vertical-align: middle;
        display: inline-block;
      }
    }
  }

  .bottom {
    padding: 12px 16px 16px;
    font-size: 12px;
    color: #888;

    .info {
      margin-bottom: 4px;
    }

    .links {
      a {
        color: #888;
        text-decoration: none;

        &:hover {
          color: $theme;
        }
      }

      .sep {
        margin: 0 8px;
        color: #ccc;
      }
    }
  }
}
</style>
